module.exports = __webpack_public_path__ + "media/assets/systems-map-icons/OpenApplyTitle-544dddb84aab47bdf238dc4a3d43d295d42d18ae023bc92122c073a4131b4381.png";